import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { when } from 'mobx'
import { observer, inject, Provider } from 'mobx-react'

import * as intercom from '../intercom'

import Websites from '../stores/websites'
import Welcome from '../stores/welcome'
import Users from '../stores/users'
import TopNav from './navigation/TopNav'
import Modal from './Modal'

import TooltipProvider from '@sidx/tooltips/provider'

import { Retain } from './injected_scripts'

@inject(['auth'])
@observer
class App extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(...args) {
    super(...args)
    const websites = new Websites()
    const welcome = new Welcome(websites)
    const users = new Users()
    this.state = { 
      websites, 
      welcome, 
      users,
      showBillingModal: false
    }
  }

  handleLogout = () => {
    intercom.shutdown()
    this.context.router.push({ pathname: '/login', state: { return_to: this.props.location } })
  }

  handleCloseBillingModal = () => {
    this.setState({ showBillingModal: false })
  }

  handleGoToBilling = () => {
    this.context.router.push('/billing')
    this.setState({ showBillingModal: false })
  }

  componentWillMount() {
    this.state.websites.load(this.props.params.website_id)
    this.authWatcher = when(
      () => !this.props.auth.loggedIn,
      () => this.handleLogout()
    )

    intercom.boot(this.props.auth.user)
  }

  componentDidMount() {
    const user = this.props.auth.user
  
    if (user && (user.customer_billing_address == null || Object.keys(user.customer_billing_address || {}).length === 0) && user.license_direct_bill === false && user.trial_info == null) {
      this.setState({ showBillingModal: true })
    }
  }

  componentWillUnmount() {
    this.authWatcher()
  }

  render() {
    const { websites, welcome, users, showBillingModal } = this.state
    const { auth, params, children } = this.props

    return (
      <Provider websites={websites} welcome={welcome} users={users}>
        <TooltipProvider>
        <div className="container app">
          <TopNav auth={auth} website_id={params.website_id} websites={websites} />
          {children}
          <Retain email={auth.user.email} />
          
          {showBillingModal && (
            <Modal 
              isOpen={true}
              onRequestClose={null}
            >
              <div style={{ 
                padding: '30px', 
                textAlign: 'center',
                backgroundColor: 'white',
                borderRadius: '8px',
                maxWidth: '400px'
              }}>
                <h3 style={{ marginBottom: '20px', color: '#333' }}>
                  Billing Update Required
                </h3>
                <p style={{ marginBottom: '20px', color: '#666' }}>
                  Your billing information is missing. Please update your billing address details.
                </p>
                <div>
                  <button 
                    onClick={this.handleGoToBilling}
                    style={{
                      padding: '10px 20px',
                      backgroundColor: '#007bff',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      marginRight: '10px',
                      cursor: 'pointer'
                    }}
                  >
                    Update Billing
                  </button>
                 
                </div>
              </div>
            </Modal>
          )}
        </div>
        </TooltipProvider>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// client/components/App.js